/* NBT: vertaalt een tekst via window.NB_T. Zonder tabel (Japans) komt het origineel terug.
   Staat de hele tekst er niet in, dan worden bekende woorden binnenin vervangen (HTML-fragmenten). */
function NBT(s) {
  var T = window.NB_T;
  if (!T || typeof s !== 'string') return s;
  if (Object.prototype.hasOwnProperty.call(T, s)) return T[s];
  var k = window.NB_TK || (window.NB_TK = Object.keys(T).sort(function (a, b) { return b.length - a.length; }));
  var uit = s;
  for (var i = 0; i < k.length; i++) {
    if (uit.indexOf(k[i]) !== -1) uit = uit.split(k[i]).join(T[k[i]]);
  }
  return uit;
}
/* NOBIASHI collectiepagina: NBT("もっと見る") in de hero, filterdropdowns, mobiele filterlade. Opbouw van hike-footwear.com.
   Filteren gaat via tag-URL's (/collections/<handle>/<tag1>+<tag2>, alfabetisch gesorteerd, AND).
   Binnen één groep geldt één keuze tegelijk, want Shopify combineert tags altijd met AND. */
(function () {
  'use strict';
  var root = document.querySelector('[data-nb-collection]');
  if (!root) return;
  var bron = root.querySelector('[data-nb-filters]');
  var basis = (bron && bron.dataset.nbBasis) || window.location.pathname.split('/').slice(0, 3).join('/');
  var actief = ((bron && bron.dataset.nbActief) || '').split(',').filter(Boolean);

  // dropdowns openen/sluiten
  function initDropdowns(scope) {
    scope.querySelectorAll('[data-nb-dd]').forEach(function (d) {
      var btn = d.querySelector('[data-nb-dd-toggle]'), panel = d.querySelector('[data-nb-dd-panel]');
      if (!btn || !panel) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = panel.classList.contains('tw-hidden');
        scope.querySelectorAll('[data-nb-dd-panel]').forEach(function (p) { p.classList.add('tw-hidden'); });
        panel.classList.toggle('tw-hidden', !open);
      });
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('[data-nb-dd]')) scope.querySelectorAll('[data-nb-dd-panel]').forEach(function (p) { p.classList.add('tw-hidden'); }); });
  }
  initDropdowns(root);

  function ga(tags) {
    var qs = new URLSearchParams(window.location.search);
    qs.delete('page');
    var sort = qs.get('sort_by');
    if (sort === 'manual') qs.delete('sort_by');
    var q = qs.toString();
    window.location.href = basis + (tags.length ? '/' + tags.slice().sort().join('+') : '') + (q ? '?' + q : '');
  }

  // klik op een tag: binnen dezelfde groep vervangen, anders toevoegen/weghalen
  document.addEventListener('click', function (e) {
    var knop = e.target.closest('[data-nb-tag]');
    if (knop) {
      var tag = knop.dataset.nbTag;
      var groep = (knop.closest('[data-nb-facet]') || {}).dataset;
      var eigen = groep && groep.nbFacet ? groep.nbFacet.split(',') : [tag];
      var uit = actief.filter(function (t) { return eigen.indexOf(t) === -1; });
      if (actief.indexOf(tag) === -1) uit.push(tag);
      ga(uit);
      return;
    }
    var sortKnop = e.target.closest('[data-nb-sort]');
    if (sortKnop) {
      var qs = new URLSearchParams(window.location.search);
      qs.delete('page');
      if (sortKnop.dataset.nbSort === 'manual') qs.delete('sort_by'); else qs.set('sort_by', sortKnop.dataset.nbSort);
      var q = qs.toString();
      window.location.href = basis + (actief.length ? '/' + actief.slice().sort().join('+') : '') + (q ? '?' + q : '');
    }
  });

  // mobiele lade: kopie van de desktopfilters, uitgeklapt als lijstjes
  var lade = root.querySelector('[data-nb-filters-mobiel]'), inhoud = root.querySelector('[data-nb-filters-mobiel-inhoud]');
  if (lade) {  // buiten de pagina-stacking-context, anders schuift de sticky header eroverheen
    var wrap = document.createElement('div'); wrap.className = 'nb'; wrap.style.position = 'relative'; wrap.style.zIndex = '9000';
    wrap.appendChild(lade); document.body.appendChild(wrap);
  }
  root.querySelectorAll('[data-nb-filters-open]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (inhoud && bron && !inhoud.children.length) {
        bron.querySelectorAll('[data-nb-dd]').forEach(function (d) {
          var blok = document.createElement('div');
          blok.className = 'tw-border border-gray rounded-md overflow-hidden';
          var kop = document.createElement('div'); kop.className = 'px-3 py-2 font-semibold text-sm bg-[#f8faf8]'; kop.textContent = d.querySelector('[data-nb-dd-toggle] span').textContent;
          var lijst = d.querySelector('[data-nb-dd-panel]').cloneNode(true);
          lijst.removeAttribute('data-nb-dd-panel');
          lijst.className = 'py-1 max-h-[320px] overflow-y-auto';
          var facet = d.getAttribute('data-nb-facet');
          if (facet) { var houder = document.createElement('div'); houder.setAttribute('data-nb-facet', facet); houder.appendChild(lijst); lijst = houder; }
          blok.appendChild(kop); blok.appendChild(lijst); inhoud.appendChild(blok);
        });
      }
      lade.classList.remove('tw-hidden'); document.documentElement.style.overflow = 'hidden';
    });
  });
  root.querySelectorAll('[data-nb-filters-close]').forEach(function (b) { b.addEventListener('click', function () { lade.classList.add('tw-hidden'); document.documentElement.style.overflow = ''; }); });

  // hero-tekst: もっと見る / 閉じる. Knop blijft weg als de tekst al helemaal past.
  (function () {
    var tekst = root.querySelector('[data-nb-col-tekst]');
    var knop = root.querySelector('[data-nb-col-meer]');
    if (!tekst || !knop) return;
    var label = knop.querySelector('[data-nb-col-meer-label]');

    function pasAan() {
      if (tekst.classList.contains('is-open')) return;
      var past = tekst.scrollHeight <= tekst.clientHeight + 4;
      knop.hidden = past;
      tekst.style.overflow = past ? 'visible' : '';
      tekst.classList.toggle('nb-col-past', past);
    }
    pasAan();
    window.addEventListener('resize', pasAan);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(pasAan);

    knop.addEventListener('click', function () {
      var open = tekst.classList.toggle('is-open');
      knop.setAttribute('aria-expanded', String(open));
      if (label) label.textContent = open ? "閉じる" : NBT("もっと見る");
      if (!open) pasAan();
    });
  })();
})();
